import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

interface Props {
  guidance_image_url: string;
}
export const DescriptionBanner: React.FC<React.PropsWithChildren<Props>> = ({ guidance_image_url }) => {
  return (
    <Wrapper>
      <Image src={guidance_image_url} alt='배너 이미지' />
      <Divider />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 24px 20px 0 20px;
`;

const Image = styled.img`
  width: 100%;
  object-fit: fill;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  margin-top: 24px;
  background: ${vars.v3Color.gray100};
`;
